<div class="header">
  <div class="header-info">
    <sh-text size="header-2">
      {{ 'syngovia.label.healthcheck' | translate }}
      ({{ this.scrollPaginationModel.totalElements }})
    </sh-text>
    <sh-text color="secondary" class="issues-date">
      {{ 'syngovia.label.On' | translate }}
      {{ issuesIdentifiedAt | localizedDate }}
    </sh-text>
  </div>

  <div class="search-container">
    <sh-dropdown
      class="dropdown-score"
      label="{{ 'syngovia.label.score' | translate }}"
      display="label"
      multi-select
    >
      <sh-menu-item
        #scoreRangeItem
        *ngFor="let range of scoreRangeDomainValues"
        label="{{ 'syngovia.label.' + range.label | translate }}"
        [value]="range.value"
        [active]="issuesFilterModel.isScoreRangeActive(range.value)"
        (click)="
          updateScoreRangeFilter(
            range.value,
            scoreRangeItem.active,
            scoreRangeItem.label
          )
        "
        (keyup)="
          updateScoreRangeFilter(
            range.value,
            scoreRangeItem.active,
            scoreRangeItem.label
          )
        "
      ></sh-menu-item>
    </sh-dropdown>

    <sh-input-text
      #searchInput
      label="{{ 'syngovia.label.search' | translate }}"
      (value-changed)="onInputChange(searchInput.value)"
    >
      <sh-icon icon="search" size="s" slot="icon"></sh-icon>
    </sh-input-text>
  </div>
</div>

<div class="tag-container">
  <ng-container #tagViewRef></ng-container>
</div>

<ng-template #tag let-data>
  <sh-tag
    *ngIf="data.type === 'date'"
    label="{{ data.value.range.start | localizedDate }}-{{
      data.value.range.end | localizedDate
    }}"
    removable
    (closed)="data.closeFn()"
  ></sh-tag>

  <sh-tag
    *ngIf="data.type === 'string'"
    label="{{ data.value }}"
    removable
    (closed)="data.closeFn()"
  ></sh-tag>
</ng-template>

<div class="table-container">
  <sh-table
    class="table"
    multiselect
    (scroll-end)="onTableScrollEnd()"
    [class.table-fixed-height]="filteredIssues.length > 10"
  >
    <sh-table-row slot="header">
      <sh-table-head
        columns="20"
        min-width="481px"
        (toggle)="
          toggleSort(
            'description',
            $event.target.hasAttribute('sort-descending')
          )
        "
      >
        {{ 'syngovia.label.description' | translate }}
      </sh-table-head>
      <sh-table-head
        columns="14"
        min-width="156px"
        (toggle)="
          toggleSort(
            'responsible',
            $event.target.hasAttribute('sort-descending')
          )
        "
      >
        {{ 'syngovia.label.responsible' | translate }}
      </sh-table-head>
      <sh-table-head
        columns="14"
        min-width="156px"
        (toggle)="
          toggleSort('category', $event.target.hasAttribute('sort-descending'))
        "
      >
        {{ 'syngovia.label.category' | translate }}
      </sh-table-head>
      <sh-table-head
        columns="14"
        min-width="156px"
        (toggle)="
          toggleSort('issueId', $event.target.hasAttribute('sort-descending'))
        "
      >
        {{ 'syngovia.label.issueId' | translate }}
      </sh-table-head>
      <sh-table-head
        columns="14"
        min-width="156px"
        (toggle)="
          toggleSort('skb', $event.target.hasAttribute('sort-descending'))
        "
      >
        {{ 'syngovia.label.skb' | translate }}
      </sh-table-head>
      <sh-table-head
        columns="12"
        min-width="100px"
        (toggle)="
          toggleSort('score', $event.target.hasAttribute('sort-descending'))
        "
      >
        {{ 'syngovia.label.score' | translate }}
      </sh-table-head>
    </sh-table-row>
    <sh-table-row *ngFor="let issue of filteredIssues">
      <sh-table-cell columns="20" min-width="481px" class="description">
        <div>{{ issue.description ?? NOT_FOUND }}</div>
      </sh-table-cell>
      <sh-table-cell columns="14" min-width="156px">
        {{ issue.responsible ?? NOT_FOUND }}
      </sh-table-cell>
      <sh-table-cell columns="14" min-width="156px">
        {{ issue.category ?? NOT_FOUND }}
      </sh-table-cell>
      <sh-table-cell columns="14" min-width="156px">
        {{ issue.issueId ?? NOT_FOUND }}
      </sh-table-cell>
      <sh-table-cell columns="14" min-width="156px">
        <sh-button
          *ngIf="issue.skb?.description"
          size="m"
          color="tertiary"
          label="{{ issue.skb?.description }}"
          (click)="onSkbClick(issue.skb?.link)"
          (keyup)="onSkbClick(issue.skb?.link)"
        >
        </sh-button>
      </sh-table-cell>
      <sh-table-cell columns="12" min-width="100px">
        <div
          class="score-severity score-severity--{{
            dnaSyngoviaScoreSeverityService.scoreSeverity(issue.score)
          }}"
        >
          {{ issue.score ?? NOT_FOUND }}
        </div>
      </sh-table-cell>
      <sh-table-row>
        <sh-table-cell columns="24">
          <div class="description-container">
            <sh-text class="header-description">
              {{ issue.description }}
            </sh-text>
            <sh-text class="detailed-description">
              {{
                issue.detailedDescription
                  ? issue.detailedDescription
                  : ('syngovia.label.noDescription' | translate)
              }}
            </sh-text>
          </div>
        </sh-table-cell>
      </sh-table-row>
    </sh-table-row>
  </sh-table>
</div>
